import PropTypes from 'prop-types';
import {useMemo, useState} from 'react';

const AccordionItem = ({title, children}) => {
  const [open, setOpen] = useState(false);

  return (
    <div className={'border-b border-gray-300 py-4'}>
      <button
        type={'button'}
        onClick={() => setOpen(prev => !prev)}
        className={'w-full flex justify-between items-center text-left'}
      >
        <span className={'text-sm tracking-widest font-medium uppercase'}>
          {title}
        </span>
        <span className={'text-xl font-light'}>
          {open ? '−' : '+'}
        </span>
      </button>

      {open && (
        <div className={'mt-4 text-sm text-gray-700 leading-relaxed'}>
          {children}
        </div>
      )}
    </div>
  );
};

AccordionItem.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

const ProductDetailInfo = ({data}) => {
  const colors = useMemo(
    () => data?.variants?.map(v => v.color) || [],
    [data],
  );

  const sizes = useMemo(
    () =>
      data?.variants?.flatMap(v =>
        v.sizes?.map(s => s.size),
      ) || [],
    [data],
  );

  return (
    <div className={'mt-6'}>
      {/* <AccordionItem title={'Description'}>
        <p className={'text-justify'}>{data.description}</p>
      </AccordionItem> */}

      <AccordionItem title={<p className={' font-serif font-semibold'}>Product Description</p>}>
        <div className={'text-base'}>
          {/* <span className={'font-semibold'}>Product Name:</span>{' '} */}
          <p className={'font-medium'}>{data.productName}</p>
          <p className={'text-justify text-base '}>{data.description}</p>
        </div>
        <div className={'text-justify text-base pt-2'}>
          <span className={'md:font-semibold font-bold'}>Category:</span>{' '}
          {data.categoryInfo?.name}
        </div>
        <div className={'text-justify text-base '}>
          <span className={'md:font-semibold font-bold'}>Brand:</span>{' '}
          {data.brandInfo?.name}
        </div>
        {/* <div>
          <span className={'font-semibold'}>Product Type:</span>{' '}
          {data.productType}
        </div> */}
        <div className={'text-justify text-base '}>
          <span className={'md:font-semibold font-bold'}>Color:</span>{' '}
          {colors.join(', ') || 'N/A'}
        </div>
      </AccordionItem>

      <AccordionItem title={<p className={' font-serif font-semibold'}>Features</p>}>
        {data.features?.length > 0 ? (
          <ul className={'list-disc pl-5 space-y-1'}>
            {data.features.map((feature, idx) => (
              <li key={idx}>{feature}</li>
            ))}
          </ul>
        ) : (
          <p className={'text-gray-500'}>No features available</p>
        )}
      </AccordionItem>

      <AccordionItem title={<p className={' font-serif font-semibold'}>Shipping & Return Policy</p>}>
        <ul className={'list-disc pl-5 space-y-1'}>
          <li className={'font-medium'}>Free shipping on products</li>
          <li>Returns are not accepted for non-defective items.</li>
          <li>Exchanges are allowed within 7 days of delivery for eligible size, color, or design issues, subject to approval and availability.</li>
          <li>Item must be unused and in original packaging</li>
          <li>No refunds for custom or personalized bags.</li>
        </ul>
      </AccordionItem>
    </div>
  );
};

ProductDetailInfo.propTypes = {
  data: PropTypes.object.isRequired,
};

export default ProductDetailInfo;
